import { getEntityMaps, getRootEntity, isRootEntity } from "@utils/capture-tree/capture-tree-utils";
import { CaptureApiClient } from "@faro-lotv/service-wires";
import { ProjectApi } from "@api/project-api/project-api";
import { assert, GUID } from "@faro-lotv/foundation";
import { CreateRevision, createRevisionForRootEntity } from "@pages/data-management/import-data/create-revision-for-lsdatav2";


/**
 * Create a Revision
 *
 * - All scans will be added directly under the root
 * - No edges to existing scans will be added
 * @param projectApiClient
 */
export async function createRevision(
  projectApiClient: ProjectApi
): Promise<CreateRevision> {
  // Get capture tree entities for main revision
  let captureTreeEntities = await projectApiClient.getCaptureTree();

  // If main revision root and/or ELS cluster are defined we need their IDs to create the revision
  let mainRevisionRoot = getRootEntity(captureTreeEntities);
  if (!mainRevisionRoot) {
    await createRevisionForRootEntity(projectApiClient);
    captureTreeEntities = await projectApiClient.getCaptureTree();
    mainRevisionRoot = captureTreeEntities.filter(isRootEntity)[0];
    assert(mainRevisionRoot, "RootEntity was created, but could not be found afterwards");
  }

  // Create revision directly without calculateCaptureTreeChanges
  const captureTreeMaps = getEntityMaps(captureTreeEntities);
  const captureTreeEntityIdsToModify = new Set<GUID>([mainRevisionRoot.id]);

  // Create revision.
  const revision = await projectApiClient.createRegistrationRevision(
    [...captureTreeEntityIdsToModify],
      /* registrationEdgeIds */[],
    CaptureApiClient.dashboard
  );

  // Flag the RootEntity as modified
  await projectApiClient.createOrUpdateRootEntityForRegistrationRevision({
    registrationRevisionId: revision.id,
    requestBody: {
      id: mainRevisionRoot.id,
    },
  });

  return {
    captureTreeRevisionId: revision.id,
    captureTreeRootAndClustersByUuid: { root: mainRevisionRoot },
    captureTreeMaps,
  };
}